export default "//file.bilionpass.com/japandx-web/0.0.1/static/stars.a81f987f-a21c27.svg";